module.exports = __webpack_public_path__ + "img/syukyaku-top-020.e8d1162b.jpg";